export default __webpack_public_path__ + "d1dafc6d195871b749025e5171bff813.png";